import React from 'react'
import { useTranslation } from 'react-i18next'

import './styles.scss'

const RecommendedProductPopin = ({ recommendedProduct, onClick, animatedProduct }) => {
  const { t } = useTranslation()

  const navigateToProduct = () => { window.location.href = `/products/${recommendedProduct.handle}` }

  const sendDataLayer = () => {
    dataLayer.push({
      event: 'xSell',
      ecommerce: {
        currencyCode: 'EUR',
        xSell: {
          products: [{
            name: recommendedProduct.title,
            id: recommendedProduct.sku,
            price: recommendedProduct.price,
            brand: 'Joone',
            category: recommendedProduct.product_category,
            variant: recommendedProduct.variant_title,
            quantity: 1
          }]
        }
      }
    })
  }

  const btnClick = () => {
    onClick(recommendedProduct)
    sendDataLayer(recommendedProduct)
  }

  return (
    <div className='recommended-product' data-sku={recommendedProduct.sku}>
      {!animatedProduct
        ? <img src={recommendedProduct.image_url} onClick={navigateToProduct} />
        : <div className='recommended-product-img'>
          <img src={recommendedProduct.image_url} className='animatedProduct' />
          <img src='https://cdn.shopify.com/s/files/1/1956/4693/files/ok.gif?v=1624003199' className='animation' />
        </div>}
      <div className='recommended-product-content'>
        <div className='recommended-product-title' onClick={navigateToProduct}>{recommendedProduct.title}</div>
        <button onClick={btnClick}>
          {t('popinCart:addToCart')}{t('general:dynamicPrice', { price: recommendedProduct.price })}
        </button>
      </div>
    </div>
  )
}

export default RecommendedProductPopin
